import Vue from 'vue'
import Vuex from 'vuex'
import monitors from './modules/monitors'
import time from './modules/time'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    monitors, time
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js